// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2167":"93547418","8203":"48adc408"}[chunkId] + ".chunk.css";
};